import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Phase 17: Onboarding Layout
 * Full-screen container with brand gradient
 */
function OnboardingLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-hayat-primary-500 via-hayat-primary-600 to-hayat-secondary-600 overflow-hidden">
      <div className="min-h-screen flex items-center justify-center p-4">
        <Outlet />
      </div>
    </div>
  );
}

export default OnboardingLayout;